export default __webpack_public_path__ + "static/media/qrmaster-screenshot-01.616b6303.png";